import { render, staticRenderFns } from "./ScoreRecord.vue?vue&type=template&id=10d21deb&scoped=true"
import script from "./ScoreRecord.vue?vue&type=script&lang=js"
export * from "./ScoreRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d21deb",
  null
  
)

export default component.exports